import { render, staticRenderFns } from "./StatsTeamTasks.vue?vue&type=template&id=621152b8&scoped=true&"
import script from "./StatsTeamTasks.vue?vue&type=script&lang=js&"
export * from "./StatsTeamTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621152b8",
  null
  
)

export default component.exports